const modeUrlObj = {
    // 生产环境
    'production': {
        baseUrl: 'https://hkqg-api.hangkong.com.cn',
    },

    // 开发环境
    'development': {
        baseUrl:'https://hkqg-test-api.hangkong.com.cn',
    }
}

export default modeUrlObj[process.env.NODE_ENV]